// extracted by mini-css-extract-plugin
export default {"service":"Farmersen_service__4yFce","imagenes":"Farmersen_imagenes__L8DHU","big":"Farmersen_big__3Nepu","littles":"Farmersen_littles__Leidt","containt":"Farmersen_containt__-kfub"};